import script from "./BaseTable.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseTable.vue?vue&type=script&setup=true&lang=js"

import "./BaseTable.vue?vue&type=style&index=0&id=0db77fa3&lang=css"

const __exports__ = script;

export default __exports__